import React from 'react'
import { Header3, Text } from '../../styles/Components'
import { LocationsWrapper } from './styles'
import { locations } from '../../pages/index'

const Locations = ({ intro = 'Our squad currently serves', additionalLocations = [] }) => {
  const allLocations = locations.concat(additionalLocations)

  return (
    <LocationsWrapper>
      <Header3 margin="0 0 18px 0">{intro}</Header3>
      <div className="location-list">
        {allLocations.map((l, i) => (
          <React.Fragment key={i}>
            <Text variant="large">{l}</Text>
            {i !== allLocations.length - 1 && (
              <Text variant="large" className="divider">
                |
              </Text>
            )}
          </React.Fragment>
        ))}
      </div>
    </LocationsWrapper>
  )
}

export default Locations
